import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

declare const io: {
  (url: string, opts?: any): any;
};

@Injectable({
  providedIn: 'root'
})
export class SocketService implements OnDestroy {
  private readonly socket: any;
  private readonly socketUrl: string;
  private destroy$ = new Subject<void>();
  private eventHandlers = new Map<string, (...args: any[]) => void>();

  constructor() {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = '8080';
    this.socketUrl = `${protocol}//${hostname}:${port}`;

    /*this.socket = io(this.socketUrl);

    this.socket.on('connect', () => console.log('[Socket] Connected'));
    this.socket.on('disconnect', () => console.log('[Socket] Disconnected'));
    this.socket.on('reconnect', (attempt: number) => console.log(`[Socket] Reconnected after ${attempt} attempts`));
    this.socket.on('reconnect_attempt', () => console.log('[Socket] Attempting to reconnect'));
    this.socket.on('reconnect_error', (err: any) => console.error('[Socket] Reconnection error:', err));
    this.socket.on('connect_error', (err: any) => console.error('[Socket] Connection error:', err));*/
  }

  onConnect(): Observable<void> {
    return new Observable<void>(observer => {
      const handler = () => observer.next();
      this.socket.on('connect', handler);
      this.eventHandlers.set('connect', handler);
    });
  }

  onDisconnect(): Observable<void> {
    return new Observable<void>(observer => {
      const handler = () => observer.next();
      this.socket.on('disconnect', handler);
      this.eventHandlers.set('disconnect', handler);
    });
  }

  joinGroup(userId: string, role: string, sessionId: string | null = null) {
    console.log(`[Socket] Joining group as ${role} (User: ${userId}, Session: ${sessionId || 'none'})`);
    this.socket.emit('join_group', userId, role, sessionId);
  }

  onUserNotification(): Observable<any> {
    return new Observable<any>(observer => {
      const handler = (data: any) => {
        console.log('[Socket] User notification:', data);
        observer.next(data);
      };
      this.socket.on('user_notification', handler);
      this.eventHandlers.set('user_notification', handler);
    });
  }
  onUserTypeNotification(): Observable<string> {
    return new Observable<string>(observer => {
      const handler = (data: string) => {
        console.log('[Socket] User type notification:', data);
        observer.next(data);
      };
      this.socket.on('user_type_notification', handler);
      this.eventHandlers.set('user_type_notification', handler);
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.eventHandlers.forEach((handler, event) => {
      this.socket.off(event, handler);
    });
    this.eventHandlers.clear();
    if (this.socket) {
      console.log('[Socket] Disconnecting');
      this.socket.disconnect();
    }
  }
}
